// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.style_test__Qq2pu {
  position: relative;
  height: 100vh;
  width: 100%;
}

.style_container_logo__8xFSI {
  background: #274aca;
  background: linear-gradient(135deg, #2196f3, #274aca);
  padding: 20px;
  height: 50vh;
}

.style_container_logo__8xFSI p,
.style_container_logo__8xFSI h1,
.style_container_logo__8xFSI h2,
.style_container_logo__8xFSI h3,
.style_container_logo__8xFSI h4,
.style_container_logo__8xFSI h5,
.style_container_logo__8xFSI h6,
.style_container_logo__8xFSI * {
  color: #fff !important;
}

.style_container_login__6A-\\+S {
  max-width: 550px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.style_link__ULU48 {
  text-decoration: none;
  color: var(--text-primary);
  align-self: flex-end;
  margin: 10px 0px;
}

.style_subtitle__y0rHi {
  color: var(--text-secondary);
  text-align: center;
  margin-bottom: 30px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SignIn/style.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;EACb,YAAY;AACd;;AAEA;;;;;;;;EAQE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,0EAA0E;EAC1E,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.test {\n  position: relative;\n  height: 100vh;\n  width: 100%;\n}\n\n.container_logo {\n  background: #274aca;\n  background: linear-gradient(135deg, #2196f3, #274aca);\n  padding: 20px;\n  height: 50vh;\n}\n\n.container_logo p,\n.container_logo h1,\n.container_logo h2,\n.container_logo h3,\n.container_logo h4,\n.container_logo h5,\n.container_logo h6,\n.container_logo * {\n  color: #fff !important;\n}\n\n.container_login {\n  max-width: 550px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background-color: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 16px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.06);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.link {\n  text-decoration: none;\n  color: var(--text-primary);\n  align-self: flex-end;\n  margin: 10px 0px;\n}\n\n.subtitle {\n  color: var(--text-secondary);\n  text-align: center;\n  margin-bottom: 30px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"test": `style_test__Qq2pu`,
	"container_logo": `style_container_logo__8xFSI`,
	"container_login": `style_container_login__6A-+S`,
	"link": `style_link__ULU48`,
	"subtitle": `style_subtitle__y0rHi`
};
export default ___CSS_LOADER_EXPORT___;
